module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oppo-stage"
  }, [_c('ul', {
    staticClass: "stage-list"
  }, [_vm._l((_vm.customerStage.allStageArray), function(item) {
    return [(item.type === 2) ? _c('li', {
      key: item.id,
      staticClass: "option",
      class: {
        'item lose-tag': item.finishStatus === 2
      }
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.jumpConfirm(item)
        }
      }
    }, [_vm._v("流失")])]) : _c('li', {
      key: item.id,
      staticClass: "item",
      class: {
        'progress': (item.finishStatus === 1 || item.finishStatus === 2) && _vm.customerStage.type !== 2
      },
      on: {
        "click": function($event) {
          _vm.isChangeStage(item)
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.stage.into_time) ? _c('ul', {
      staticClass: "mini-modal"
    }, [_c('li', {
      staticClass: "p break-all"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("阶段用时：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.stage.into_time) + "~" + _vm._s(item.stage.out_time))])]), _vm._v(" "), _c('li', {
      staticClass: "p"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("停留时间：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.stage.stayTime))])]), _vm._v(" "), _c('li', {
      staticClass: "p"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("工作情况：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.stage.workFinish.finish) + "/" + _vm._s(item.stage.workFinish.total))])])]) : _vm._e()])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de92867","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/customer-stage-flow.vue
// module id = 1212
// module chunks = 82